<template>
  <div class="walmart">
    <Header />
    <div class="walmart-main">
      <RewardsChild :rewardsChildData="rewardsChildData"></RewardsChild>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import RewardsChild from "./mycom/rewardsChild.vue";
import { walmart } from "@/utlis/storageData.js";
export default {
  components: { Header, Footer, RewardsChild },
  data() {
    return {
      rewardsChildData: walmart,
    };
  },
  created() {
    this.rewardsChildData.number = this.$route.query.number;
  },
};
</script>
<style scoped>
.walmart {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.walmart-main {
  width: calc(100% - 175px);
  padding: 20px 87.5px;
}
</style>
<style scoped>
/* 媒体查询 */
@media only screen and (max-width: 1280px) {
  .walmart-main {
    width: calc(100% - 95px);
    padding: 20px 47.5px;
  }
}
@media only screen and (max-width: 1080px) {
  .walmart-main {
    width: calc(100% - 45px);
    padding: 20px 27.5px;
  }
}
@media only screen and (max-width: 1000px) {
  .walmart-main {
    width: calc(100% - 40px);
    padding: 20px 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/walmart.vue